export const orangeButton = "text-white text-lg xl:text-xl font-semibold px-4 xl:px-5 py-2 xl:py-3 bg-link hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full";

export const buttonNoPadding = "text-charmOrange text-lg xl:text-xl font-semibold hover:text-integrationRequestTextHover w-fit border-b border-charmOrange";

export const orangeButtonCentered = "text-white text-lg xl:text-xl font-semibold px-4 xl:px-5 py-2 xl:py-3 bg-link hover:text-integrationRequestTextHover hover:bg-charmHover w-fit mx-auto rounded-full";

export const heroContainer = "bg-cover bg-left-top md:bg-right 2xl:bg-right-bottom h-screen flex flex-col items-center justify-center"

export const legalContainer = "w-full mx-auto flex flex-col bg-charmPurple px-10 md:px-8 2xl:px-28 3xl:px-64 pb-14";

export const navbarContainer = "w-full h-[45px] xs:h-[60px] xl:h-[75px] flex items-center flex-row justify-between shadow-md bg-[#26051C] md:px-8 xl:px-12";

export const formTextboxContainer = "w-full flex flex-col items-center mx-auto";

export const formTextboxLabel = "w-full text-left font-proximanova font-[500] text-[18px] text-[#505050] mb-1";

export const formTextbox = "block py-2.5 px-4 w-full text-lg md:text-xl 2xl:text-2xl text-gray-900  appearance-none focus:outline-none focus:ring-0 focus:border focus:border-usersLink bg-neutral-light"

export const formTextarea = "block py-2.5 px-4 w-full text-lg md:text-xl 2xl:text-2xl text-gray-900 appearance-none focus:outline-none focus:ring-0 focus:border focus:border-usersLink h-36 bg-neutral-light"

//************************* Navbar ************************* 

export const newNavbarContainer = "w-full h-[45px] xs:h-[60px] xl:h-[75px] flex items-center bg-black bg-opacity-50 flex-row justify-between md:px-12 xl:px-20 fixed top-0 left-0 right-0 transition-all duration-300"

export const navbarButtonContainer = "hidden sm:flex flex-row h-full gap-8 xl:gap-12 mr-4"

export const newNavbarButton = "w-fit text-white text-lg xl:text-xl font-semibold py-[13.5px] xl:py-[21px] border-b-4 border-transparent hover:border-link transition-all duration-300"

export const navbarMenuButton = "sm:hidden mx-4 xs:mx-6"

export const menuNavbarContainer = "sm:hidden fixed top-0 right-0 bg-[#26051C] p-4 gap-1 flex flex-col w-full h-screen transition-transform duration-500"

export const menuNavbarX = "-mt-2 text-white self-end text-xl font-bold px-1"

export const menuNavbarButtonContainer = "w-full flex items-center justify-center"

export const menuNavbarButton = "w-fit text-white text-lg xl:text-xl font-semibold py-2 border-b-4 border-transparent hover:border-link transition-all duration-300"

export const navbarFixedStyling = "fixed top-0 left-0 right-0 z-50"

//************************* Hero ************************* 

export const heroBackground = { backgroundImage: `url(https://charmhealth-marketplace-assets.s3.amazonaws.com/Homepage/BackgroundImage.png)` };

export const heroContentContainer = "w-full h-full flex items-center";

export const heroContentStyling = "w-full flex flex-col py-20 md:px-12 xl:px-20 items-start text-center"

export const heroTitle = "w-full md:w-[40rem] lg:w-[52rem] 2xl:w-[58rem] md:text-left px-4 sm:px-6 text-5xl md:text-6xl xl:text-7xl 2xl:text-8xl text-heroTitleText font-all-round-gothic-bold"

export const heroSubtitle = "mt-10 sm:mt-12 w-full md:w-[42.8rem] lg:w-[45rem] 2xl:w-[50rem] md:text-left px-4 sm:px-10 md:px-6 text-lg md:text-xl 2xl:text-2xl text-heroSubtitleText font-proxima-nova"

export const heroSearchbarContainer = "w-full mt-10 sm:mt-12 mx-auto md:mx-0 px-4 sm:px-6"

export const heroSearchbar = "md:w-[42.8rem] lg:w-[46rem] 2xl:w-[52rem] p-4 bg-heroSearchbar h-16 rounded-full border-2 border-exploreSearchBorder flex flex-row items-center relative"

export const heroSearchbarCategoriesContainer = "w-fit flex items-center"

export const heroSearchbarCategoriesButton = "px-6 h-8 flex flex-row items-center text-sm sm:text-xl border-r-[2px] border-exploreSearchBorder font-medium"

export const heroSearchbarCategoriesDropdownContainer = "absolute top-[68px] left-0 w-fit sm:pr-8 px-4 bg-heroSearchbar shadow-sm border-2 border-exploreSearchBorder max-h-80 overflow-y-auto"

export const heroSearchbarCategoriesDropdownItem = "w-full text-left text-lg md:text-xl 2xl:text-2xl px-4 py-2 text-gray-800 hover:bg-exploreNavBackgroundSelected hover:text-white focus:outline-none"

export const heroSearchbarSuggestionsDropdownContainer = "absolute top-[68px] left-0 w-fit px-4 bg-heroSearchbar shadow-sm border-2 border-exploreSearchBorder max-h-[30rem] overflow-y-auto"

export const heroSearchbarIconContainer = "ml-6 flex-grow flex justify-center"

export const navbarLogoContainer = "w-48 xs:w-60 xl:w-72 mx-4 xs:mx-6"

//************************* Users ************************* 

export const usersContainer = "w-full my-12"

export const usersTitle = "w-full md:w-11/12 2xl:w-[1536px] 3xl:w-[2048px] md:mx-auto text-center text-usersTitle font-all-round-gothic-demi text-4xl md:text-5xl xl:text-6xl px-4 xs:px-12 md:px-4 font-all-round-gothic-bold"

export const usersSubtitle = "mt-8 w-full md:w-11/12 lg:w-[1024px] xl:w-[1280px] 2xl:w-[1536px] md:mx-auto text-usersSubtitle text-center md:text-left text-lg md:text-xl 2xl:text-2xl px-4 xs:px-12 md:px-4 lg:px-8"

export const usersUserContainer = "mt-12 w-full sm:w-[768px] md:w-[944px] lg:w-[1200px] xl:w-[1392px] 2xl:w-[1632px] grid grid-cols-1 sm:grid-cols-2 md:grid-cols-6 lg:grid-cols-5 gap-6 3xl:gap-16 px-4 xs:px-12 sm:px-20 md:px-4 xl:px-8 mx-auto"